import { Modal, Row, Col, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { checkForAPISuccess, responseToastHandler, showErrorToast } from '../../../Common/commonFunctions';
import {
  fetchPreviousAndCurrentInformationForSensor,
  updateSensorById,
  revertDetachedSensor,
  forceRevertSensor,
} from '../../../api';
import _ from 'lodash';
import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { ClipLoader } from 'react-spinners';
import { useDispatch } from 'react-redux';
import { UPDATE_SENSOR_INFORMATION, REMOVE_DETACHED_SENSOR, ADD_NEW_SENSOR } from '../../../store/actions';
import { RESPONSE_ATTACHED_SENSOR_CODE, RESPONSE_LOCATION_BLOCKED_CODE, RESPONSE_NO_RECORDS_FOUND_CODE } from '../../../Common/constants';

const SensorRevert = props => {
  const dispatch = useDispatch();
  const ATTACHED = 'attached',
    DETACHED = 'detached',
    VALUE_UPDATED = 'value_updated';
  const useQueryConfiguration = {
    enabled: false,
    retry: false,
    retryOnMount: false,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  };
  const revertPopupRows = ['axial', 'vertical', 'location'];
  const breakPoints = { lg: 4, xs: 4, sm: 4, md: 4, xl: 4 };

  const [utils, setUtils] = useState({
    allSensorInfo: [],
    currentIndex: 0,
    getInfoQueryStatusCode: 0,
    attachedSensorMsg: '',
    rowUnderRevert: '',
    clickedField: '',
    locationOccupiedMsg : ""
  });

  const removeCurrentSensor = () => {
    let updatedSensors = _.clone(utils.allSensorInfo);
    updatedSensors.splice(utils.currentIndex, 1);
    if (updatedSensors.length > 0) {
      setUtils({
        ...utils,
        attachedSensorMsg: '',
        allSensorInfo: updatedSensors,
        currentIndex: utils.currentIndex > 0 ? utils.currentIndex - 1 : 0,
      });
    } else {
      setUtils({ ...utils, currentIndex: 0, allSensorInfo: [], attachedSensorMsg: '' });
    }
  };

  const getPreviousAndCurrentInfo = async () => {
    const response = await fetchPreviousAndCurrentInformationForSensor(props.componentId);
    return response?.data;
  };

  const updateSensor = async () => {
    const updatedInfo = _.cloneDeep(utils.allSensorInfo[utils.currentIndex]);
    updatedInfo.current[utils.rowUnderRevert] = updatedInfo.previous[utils.rowUnderRevert];

    let payload = {};
    if (utils.clickedField === 'axial' || utils.clickedField === 'vertical') {
      payload = {
        metadata: {
          install_info: {
            axial: updatedInfo?.current?.axial,
            vertical: updatedInfo?.current?.vertical,
          },
        },
      };
    } else if (utils.clickedField === 'location') {
      payload = {
        installLocation: updatedInfo?.current?.location,
      };
    }

    const response = await updateSensorById(updatedInfo.id, payload);
    return response?.data;
  };



  const revertSensor = async () => {
    let response = {},
    currentSensor = utils.allSensorInfo[utils.currentIndex];
    const payload = { sensorId: currentSensor.id, componentId: props.componentId };
    response = _.isEmpty(utils.attachedSensorMsg)
      ? await revertDetachedSensor(payload)
      : await forceRevertSensor(payload);
    return response?.data;
  };

  const getPreviousAndCurrentInfoQuery = useQuery('get-previous-and-current-sensor-info', getPreviousAndCurrentInfo, {
    ...useQueryConfiguration,
  });

  const updateSensorQuery = useQuery('update-sensor', updateSensor, { ...useQueryConfiguration });

  const revertSensorQuery = useQuery('revert-sensor', revertSensor, { ...useQueryConfiguration });



  useEffect(() => {
    if (!_.isEmpty(utils.rowUnderRevert)) {
      updateSensorQuery.refetch();
    }
  }, [utils.rowUnderRevert]);


  useEffect(() => {
    if (revertSensorQuery.isFetched) {
      if (
        revertSensorQuery.isSuccess &&
        (checkForAPISuccess(revertSensorQuery?.data?.statusCode) ||
          _.isEqual(revertSensorQuery?.data?.statusCode, RESPONSE_ATTACHED_SENSOR_CODE)
         || _.isEqual(revertSensorQuery?.data?.statusCode,RESPONSE_LOCATION_BLOCKED_CODE)
         || _.isEqual(revertSensorQuery?.data?.statusCode, RESPONSE_NO_RECORDS_FOUND_CODE)
        )
      ) {
        const data = revertSensorQuery?.data;
        if (_.isEqual(revertSensorQuery?.data?.statusCode, RESPONSE_ATTACHED_SENSOR_CODE)) {
          setUtils({ ...utils, attachedSensorMsg: revertSensorQuery?.data?.statusMessage });

        } else if(_.isEqual(revertSensorQuery?.data?.statusCode,RESPONSE_LOCATION_BLOCKED_CODE)){
          setUtils({...utils, locationOccupiedMsg : revertSensorQuery?.data?.statusMessage})
        } else {
          const currentSensor = utils.allSensorInfo[utils.currentIndex];
          if (currentSensor.state === ATTACHED) {
            dispatch({ type: REMOVE_DETACHED_SENSOR, payload: currentSensor.id });
          } else {
            dispatch({
              type: ADD_NEW_SENSOR,
              payload: {
                id: currentSensor.id,
                location: currentSensor?.location,
                metadata: {
                  axial: currentSensor?.axial,
                  vertical: currentSensor?.vertical,
                },
                bearingInformation: data.data.bearingInformation
              },
            });
          }

          removeCurrentSensor();
          const onSuccess = { message: 'Sensor information updated successfully', callBack: () => {} };
          responseToastHandler(revertSensorQuery?.data?.statusCode, null, onSuccess, null);
        }
      } else {
        showErrorToast("Failed to revert sensor");
      }
      revertSensorQuery.remove();
    }
  }, [revertSensorQuery.isFetched]);

  useEffect(() => {
    if (updateSensorQuery.isFetched) {
      if (updateSensorQuery.isSuccess && checkForAPISuccess(updateSensorQuery?.data?.statusCode) || _.isEqual(updateSensorQuery?.data?.statusCode,RESPONSE_LOCATION_BLOCKED_CODE)) {
        const data = updateSensorQuery?.data;
        if(_.isEqual(data?.statusCode,RESPONSE_LOCATION_BLOCKED_CODE)){
          responseToastHandler(data?.statusCode, { message: `${data.statusMessage}`, callBack: () => {} }, null, null);
          updateSensorQuery.refetch()
        }
      else {
      let updatedInfo = _.cloneDeep(utils.allSensorInfo),
          ind = utils.currentIndex,
          row = utils.rowUnderRevert;
        updatedInfo[ind].current[row] = updatedInfo[ind].previous[row];
        setUtils({ ...utils, allSensorInfo: updatedInfo, rowUnderRevert: '' });

        const metadata = {
          axial: updatedInfo[ind].current.axial,
          vertical: updatedInfo[ind].current.vertical,
        };
        dispatch({
          type: UPDATE_SENSOR_INFORMATION,
          payload: { metadata: metadata, id: updatedInfo[ind].id, location: updatedInfo[ind].current.location },
        });
        if (_.isEqual(updatedInfo[ind].current, updatedInfo[ind].previous)) {
          removeCurrentSensor();
        }
        const onSuccess = { message: 'Sensor information reverted successfully.', callBack: () => {} };
        responseToastHandler(data?.statusCode, null, onSuccess, null);
      }
      } else {
        setUtils({ ...utils, rowUnderRevert: '' });
        const onFailure = { message: 'Failed to revert sensor information.', callBack: () => {} };
        responseToastHandler(updateSensorQuery?.data?.statusCode, onFailure, null, onFailure);
      }
      updateSensorQuery.remove();
    }
  }, [updateSensorQuery.isFetched]);

  useEffect(() => {
    getPreviousAndCurrentInfoQuery.refetch();
  }, []);

  useEffect(() => {
    if (getPreviousAndCurrentInfoQuery.isFetched) {
      if (
        getPreviousAndCurrentInfoQuery.isSuccess &&
        checkForAPISuccess(getPreviousAndCurrentInfoQuery?.data?.statusCode)
      ) {
        if (!_.isEmpty(getPreviousAndCurrentInfoQuery?.data?.data)) {
          const data = getPreviousAndCurrentInfoQuery.data.data;
          let allSensors = [];
          Object.keys(data).forEach(state => {
            if (!_.isEmpty(data[state])) {
              Object.keys(data[state]).forEach(id => {
                const sensorObj = {},
                  currentSensor = data[state][id];
                sensorObj.id = id;
                sensorObj.state = state;
                if (state === VALUE_UPDATED) {
                  sensorObj.current = currentSensor['CURRENT'];
                  sensorObj.previous = currentSensor['PREVIOUS'];
                 } else {
                  sensorObj.location = currentSensor.location;
                  sensorObj.axial = currentSensor.axial;
                  sensorObj.vertical = currentSensor.vertical;
                  sensorObj.currentState = currentSensor.currentState;
                }
                allSensors.push(sensorObj);
              });
            }
          });
          setUtils({
            ...utils,
            allSensorInfo: allSensors,
            getInfoQueryStatusCode: getPreviousAndCurrentInfoQuery?.data?.statusCode,
          });
        }
      } else {
        setUtils({
          ...utils,
          getInfoQueryStatusCode: getPreviousAndCurrentInfoQuery?.data?.statusCode,
        });
        showErrorToast("Failed to fetch current and install time information.");
      }
      getPreviousAndCurrentInfoQuery.remove();
    }
  }, [getPreviousAndCurrentInfoQuery.isFetched]);

  const returnHeaderColumns = (value, className) => (
    <Col className={className} md={4} lg={4} xs={4} xl={4} sm={4}>
      {value}
    </Col>
  );

  const returnIcon = (icon, color, className, width) => (
    <Icon width={width} className={className} color={color} icon={icon} />
  );

  const checkSensorRevertPossiblility = () =>
    !_.isEmpty(utils.allSensorInfo) && !_.isEmpty(utils.allSensorInfo[utils.currentIndex]);

  const checkIfUpdatesOnGoing = () => updateSensorQuery.isFetching || revertSensorQuery.isFetching;

  const returnMetadataUpdatedSensorColumns = (rowName, previous, current, id, direction) => (
    <Col
      className={`${!_.isEmpty(previous) && previous !== current && direction === 'middle' && 'link'}
                        ${checkIfUpdatesOnGoing() && 'disable-click'}`}
      {...breakPoints}
    >
      {rowName !== 'id' ? (
        direction === 'middle' ? (
          !_.isEmpty(previous) ? (
            <>
              {utils.rowUnderRevert === rowName && updateSensorQuery.isFetching ? (
                <ClipLoader color="#075978" speedMultiplier={1.1} size={25} />
              ) : (
                <>
                  <span onClick={() => setUtils({ ...utils, rowUnderRevert: rowName, clickedField: rowName })}>
                    {previous}
                  </span>
                  {previous === current && returnIcon('feather-check', 'green', 'ml-2', 18)}
                </>
              )}
            </>
          ) : (
            returnIcon('feather-minus', 'gray', '', 18)
          )
        ) : !_.isEmpty(current) && current !== previous ? (
          <>
            {' '}
            {current} {returnIcon('feather-check', 'green', 'ml-2', 18)}{' '}
          </>
        ) : (
          <>{returnIcon('feather-minus', 'gray', '', 18)}</>
        )
      ) : (
        id
      )}
    </Col>
  );

  const returnPreviousAndCurrentButtons = target =>
    !_.isEmpty(utils.allSensorInfo) &&
    utils.allSensorInfo.length > 1 && (
      <Button
        disabled={
          utils.currentIndex === (target === 'Next' ? utils.allSensorInfo.length - 1 : 0) || checkIfUpdatesOnGoing()
        }
        onClick={() =>
          setUtils({ ...utils, currentIndex: target === 'Next' ? utils.currentIndex + 1 : utils.currentIndex - 1 })
        }
        className={`${'secondary-button'}`}
      >
        {target}
      </Button>
    );

  return (
    <Modal show={true} backdrop="static" size="lg" onHide={() => props.hidePopup()}>
      <Modal.Header closeButton>
        <h4 className="font-weight-bold">Sensor Revert</h4>
      </Modal.Header>

      <Modal.Body>
        {getPreviousAndCurrentInfoQuery.isFetching || revertSensorQuery.isFetching ? (
          <div className="text-center my-5">
            <ClipLoader color="#075978" />
          </div>
        ) : (
          <>
            {checkForAPISuccess(utils.getInfoQueryStatusCode) ? (
              <>
                {checkSensorRevertPossiblility() ? (
                    !_.isEmpty(utils.locationOccupiedMsg) ? (
                      <div className="my-4 text-left font-weight-bold">
                        {utils.locationOccupiedMsg}
                        <br />
                        Please update the location or detach the sensor before proceeding.
                      </div>

                    ) :
                    !_.isEmpty(utils.attachedSensorMsg) ? (
                    <div className="my-4 text-left font-weight-bold">
                      {utils.attachedSensorMsg}
                      <br />
                    Do you want to detach it from there and attach it here?
                      </div>
                    ) : (
                    <>
                     <Row className="align-items-center my-2">
                       <Col xs="auto" className="font-weight-bold text-end">
                        ID:
                      </Col>
                      <Col className="text-start font-weight-bold">
                       {utils.allSensorInfo[utils.currentIndex]["id"]}
                       {utils.allSensorInfo[utils.currentIndex]["currentState"]
                       ? ` (${utils.allSensorInfo[utils.currentIndex]["currentState"]})`
                       : ""}
                      </Col>
                     </Row>


                  <div>
                    <Row style={{ fontSize: '14px' }} className="text-center my-3">
                        {returnHeaderColumns('Parameter', 'font-weight-bold')}
                        {returnHeaderColumns('Install time info', 'font-weight-bold')}
                        {returnHeaderColumns('User updated info', 'font-weight-bold')}
                      </Row>
                      {revertPopupRows.map((rowName, index) => {
                        const currentSensor = utils.allSensorInfo[utils.currentIndex];
                        const columnValue = currentSensor[rowName];
                        const previousValue =
                          currentSensor.state === VALUE_UPDATED ? currentSensor?.previous?.[rowName] : '';
                        const currentValue =
                          currentSensor.state === VALUE_UPDATED ? currentSensor?.current?.[rowName] : '';
                        return (
                          <>
                              <Row className={`p-0 my-0 text-center ${index % 2 === 0 ? 'revert-even' : 'revert-odd'}`}>
                                <Col className="font-weight-bold text-left " {...breakPoints}>
                                  {rowName}
                                </Col>
                                {currentSensor.state !== VALUE_UPDATED ? (
                                  <>
                                    <Col {...breakPoints}>
                                      {currentSensor.state === DETACHED
                                        ? columnValue
                                        : returnIcon('feather-minus', 'gray', '', 18)}
                                    </Col>
                                    <Col {...breakPoints}>
                                      {currentSensor.state === ATTACHED
                                        ? columnValue
                                        : returnIcon('feather-minus', 'gray', '', 18)}
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    {returnMetadataUpdatedSensorColumns(
                                      rowName,
                                      previousValue,
                                      currentValue,
                                      currentSensor.id,
                                      'middle'
                                    )}
                                    {returnMetadataUpdatedSensorColumns(
                                      rowName,
                                      previousValue,
                                      currentValue,
                                      currentSensor.id,
                                      'right'
                                    )}
                                  </>
                                )}
                              </Row>
                          </>
                        );
                      })}
                    </div>
                    </>
                  )
                ) : (
                  <div className="text-center my-5 font-weight-bold">
                    No sensors to revert
                  </div>
                )}
              </>
            ) : (
              <div className="text-center my-5 font-weight-bold">
                Failed to get install time and current information.
              </div>
            )}
          </>
        )}
      </Modal.Body>

      {checkSensorRevertPossiblility() && !getPreviousAndCurrentInfoQuery.isFetching && (
        <Modal.Footer className="mt-2">
          {_.isEmpty(utils.attachedSensorMsg) && _.isEmpty(utils.locationOccupiedMsg) ? (
            <div style={{ display: 'flex', justifyContent: 'space-around' }} className="w-100">
              {returnPreviousAndCurrentButtons('Previous')}
              <Button
                onClick={() => revertSensorQuery.refetch()}
                disabled={utils.allSensorInfo[utils.currentIndex].state === VALUE_UPDATED || checkIfUpdatesOnGoing()}
              >
                Revert
              </Button>
             {returnPreviousAndCurrentButtons('Next')}
            </div>
          ) : (
               !utils.locationOccupiedMsg ?
               <div>
                <Button
                disabled={revertSensorQuery.isFetching}
                onClick={() => setUtils({ ...utils, attachedSensorMsg: '' })}
                className="secondary-button"
              >
                No
              </Button>
              <Button disabled={revertSensorQuery.isFetching} onClick={() => revertSensorQuery.refetch()}>
                Yes
              </Button>
            </div>
            : "")}
        </Modal.Footer>
      )}
    </Modal>
  );
};
export default SensorRevert;
